module.exports = __webpack_public_path__ + "media/cuu/ppal_cuu_1_old-116855d3.jpg";